import { render } from "./AppBreadcrumbs.vue?vue&type=template&id=328897ae&scoped=true&ts=true"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=ts"

import "./AppBreadcrumbs.vue?vue&type=style&index=0&id=328897ae&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328897ae"]])

export default __exports__